import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		marginLeft: '2rem',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center',
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(20)
	},
	subHeading: {
		marginLeft: '2rem',
		marginBottom: '1rem',
		color: theme.palette.primary.main,
		textAlign: 'center',
		fontWeight: 600,
		fontSize: theme.typography.pxToRem(16)
	},
	buttonWrapper: {
		display: 'flex',
		justifyContent: 'center',
		margin: '2rem',
		columnGap: '1rem'
	},
	container: {
		paddingTop: '2rem',
		paddingLeft: '2rem',
		paddingRight: '2rem',

		height: '100vh'
	},
	wrapper: {
		height: '100%',
		width: '100%'
	},
	configWrapper: {
		display: 'flex'
	},
	containerWrapper: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		justifyContent: 'center',
		rowGap: '50px',
		height: '60vh'
	},
}));
